import apiClient from './client';

/** 运行时部署（部署管理页）API 客户端；Agent API Token 见 agentApiTokens.ts。 */

export interface RuntimeInfo {
  healthy?: boolean;
  cpu_percent?: number;
  memory_mb?: number;
  stub?: boolean;
  fallback_reason?: string;
  [key: string]: unknown;
}

export interface AgentRuntime {
  id: string;
  framework: string;
  status: string;
  sandbox_id: string | null;
  container_id: string | null;
  port: number | null;
  endpoint_url: string | null;
  runtime_info: RuntimeInfo | null;
  target_path: string | null;
  deployed_at: string | null;
  stopped_at: string | null;
  error_message: string | null;
  agent_name?: string | null;
  /** 固定镜像（P3-① 镜像版本绑定）：NULL=不钉定，沿用框架默认解析 */
  image_ref: string | null;
}

export interface ShutdownRuntimePayload {
  export_data?: boolean;
  reason?: string;
}

export async function listAgentRuntimes(agentId: string): Promise<AgentRuntime[]> {
  const res = await apiClient.get(`/agents/${agentId}/runtime`);
  return res.data.runtimes;
}

export async function createAgentRuntime(agentId: string, framework: string): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime`, { framework, config: {} });
}

export async function startRuntime(agentId: string): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime/start`);
}

export async function stopRuntime(agentId: string): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime/stop`);
}

export async function restartRuntime(agentId: string): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime/restart`);
}

export async function unpauseRuntime(agentId: string): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime/unpause`);
}

export async function pauseRuntime(agentId: string): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime/pause`);
}

export async function shutdownRuntime(agentId: string, payload?: ShutdownRuntimePayload): Promise<void> {
  await apiClient.post(`/agents/${agentId}/runtime/shutdown`, payload ?? {});
}

export async function deleteAgentRuntime(agentId: string): Promise<void> {
  await apiClient.delete(`/agents/${agentId}/runtime`);
}

export async function fetchRuntimeLogs(agentId: string, lines = 100): Promise<string[]> {
  const res = await apiClient.get(`/agents/${agentId}/runtime/logs`, { params: { lines } });
  return res.data.logs;
}
